import React, { useState, useEffect } from "react";
import VendorType from "../payments/types/Vendor";
import Vendor from "./Vendor";
import { AREA_PATHS, VANCOUVER_PATHS, VICTORIA_PATHS } from "./constants";

export default function VendorsMap({ city, vendors }: { city: string; vendors: VendorType[] }) {
  const [selectedAreas, setSelectedAreas] = useState<string[]>([]);

  const cityAreas = AREA_PATHS.filter((area) => area.city === city);
  const isVancouver = city === "Vancouver";

  useEffect(() => {
    setSelectedAreas([]);
  }, [city]);

  const handleAreaClick = (areaName: string) => {
    if (selectedAreas.includes(areaName)) {
      setSelectedAreas(selectedAreas.filter((name) => name !== areaName));
    } else {
      setSelectedAreas([areaName, ...selectedAreas]);
    }
  };

  const convertKebabToTitle = (kebab: string) => {
    return kebab
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const filterCallback = (area: string, vendor: VendorType) => {
    return vendor.locations.some((location) => location.neighbourhood === area);
  };

  return (
    <div className="vendorsMap-main">
      <div className="vendorsMap-map">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 640 556"
          enableBackground="new 0 0 640 556"
          xmlSpace="preserve"
        >
          {isVancouver ? (
            <>
              {VANCOUVER_PATHS.map((path, index) => (
                <polygon key={index} fill="#dfe6e9" points={path} />
              ))}
            </>
          ) : (
            <g>
              {VICTORIA_PATHS.map((path, index) => (
                <path key={index} fill="#dfe6e9" d={path} />
              ))}
            </g>
          )}
          <g>
            {cityAreas.map((area, index) => {
              const hasVendors = vendors.some(
                (vendor) => vendor.locations[0].neighbourhood === area.name
              );
              const isSelected = selectedAreas.indexOf(area.name) > -1;
              const fillColour = hasVendors ? (isSelected ? "#ee2123" : "#ccc") : "#dfe6e9";
              return (
                <path
                  className={hasVendors ? "has-vendors" : ""}
                  key={index}
                  id={area.name}
                  d={area.dPath}
                  strokeMiterlimit="10"
                  tabIndex={hasVendors ? 0 : undefined}
                  aria-label={
                    hasVendors ? `Vendors in ${convertKebabToTitle(area.name)}` : undefined
                  }
                  role={hasVendors ? "button" : undefined}
                  onClick={hasVendors ? () => handleAreaClick(area.name) : undefined}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      e.stopPropagation();
                      handleAreaClick(area.name);
                    }
                  }}
                  fill={fillColour}
                  stroke="#5F5E58"
                />
              );
            })}
          </g>
        </svg>
      </div>
      <div className="vendorsMap-vendors">
        {selectedAreas.length > 0 ? (
          selectedAreas.map((area, idx) => (
            <div key={idx + "-" + area} className="vendorsMap-vendors-group">
              <h2 className="h3">{convertKebabToTitle(area)}</h2>
              {vendors
                .filter((vendor) => filterCallback(area, vendor))
                .map((vendor) => (
                  <Vendor vendor={vendor} area={area} key={vendor.id} />
                ))}
            </div>
          ))
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
}
